module.exports = __webpack_public_path__ + "img/online-mentoring.726bbf2e.png";